<script>
	import { scaleAdOnHover, startAd } from '../../../../share/ads';
	import { getText } from '../../../../share/utils';

	let ads = {
		// CFIT-V0055_Langhantel-Paar-A-720x480-adform
		cfitRec: {
			element: false,
			fallbackImgUrl: './../commercial/01.Home/04.apps-und-ads/cfitRec/fallback.webp',
			imageAltText: 'clever Fit - Langhantel-Paar - interactive Ad',
			iframeIndexUrl: './../commercial/01.Home/04.apps-und-ads/cfitRec/index.html',
			playTimeMs: 13000,
			playing: false,
			autoStopTimeOut: false,
			scale: 1,
			origWidth: 720,
			origHeight: 480
		},
		// CFIT-V0114_Performance-3oo_x_25o-adform
		cfitPerformance: {
			element: false,
			fallbackImgUrl: './../commercial/17.Health_And_Care/02.cleverfit/Performance-3oo_x_25o/fallback.webp',
			imageAltText: 'clever Fit - Performance - interactive Ad',
			iframeIndexUrl: './../commercial/17.Health_And_Care/02.cleverfit/Performance-3oo_x_25o/index.html',
			// playTimeMs: 13000,
			playTimeMs: 12313000,
			playing: false,
			autoplay: true,
			autoStopTimeOut: false,
			scale: 1,
			maxScale: 1,
			origWidth: 300,
			origHeight: 250
		},
		// CFIT-V0055_Langhantel-Paar-A-970x250-adform
		cfitWide: {
			element: false,
			fallbackImgUrl: './../commercial/17.Health_And_Care/02.cleverfit/Paar-970x250/fallback.webp',
			imageAltText: 'clever Fit - Langhantel-Paar - interactive Ad',
			iframeIndexUrl: './../commercial/17.Health_And_Care/02.cleverfit/Paar-970x250/index.html',
			playTimeMs: 13000,
			playing: false,
			autoplay: true,
			autoStopTimeOut: false,
			scale: 1,
			maxScale: 1,
			origWidth: 970,
			origHeight: 250
		},
		// CFIT-V0055_Bauch-Frau-A-120x600-google
		cfitBauchFrau: {
			element: false,
			fallbackImgUrl: './../commercial/17.Health_And_Care/02.cleverfit/Frau-120x600/fallback.webp',
			imageAltText: 'clever Fit - Frau - interactive Ad',
			iframeIndexUrl: './../commercial/17.Health_And_Care/02.cleverfit/Frau-120x600/index.html',
			playTimeMs: 13000,
			playing: false,
			autoplay: true,
			autoStopTimeOut: false,
			scale: 1,
			maxScale: 1,
			origWidth: 120,
			origHeight: 600
		},
		// CFIT-V0055_Bauch-Mann-A-120x600-google
		cfitBauchMann: {
			element: false,
			fallbackImgUrl: './../commercial/17.Health_And_Care/02.cleverfit/Mann-120x600/fallback.webp',
			imageAltText: 'clever Fit - Mann - interactive Ad',
			iframeIndexUrl: './../commercial/17.Health_And_Care/02.cleverfit/Mann-120x600/index.html',
			playTimeMs: 13000,
			playing: false,
			autoplay: true,
			autoStopTimeOut: false,
			scale: 1,
			maxScale: 1,
			origWidth: 120,
			origHeight: 600
		}
	};
</script>

<div class="page-health-cleverfit marginbox">
	<div class="flex structure">
		<div class="flex structure-1">
			<div class="flex element rec">
				<!-- Beginning - Ad: cfitRec -->
				<div bind:this={ads.cfitRec.element} class="content"
					 style="
							 --scale: {ads.cfitRec.scale};
							 --origWidth: {ads.cfitRec.origWidth || 0}px;
							 --origHeight: {ads.cfitRec.origHeight || 0}px;
						">
					{#if ads.cfitRec.playing}
						<div class="commercial" class:playing={ads.cfitRec.playing}>
							<!-- PLAYING -->
							<img loading="eager" alt="Website-Screenshot"
								 src="./../img/01.Home/04.apps-und-ads/cfit-hintergrund.webp">
							<div class="container-overlay">
								<img loading="eager" alt={ads.cfitRec.imageAltText} src={ads.cfitRec.fallbackImgUrl}/>
								<iframe class="scaled-iframe" scrolling="no" src={ads.cfitRec.iframeIndexUrl}
										style="--bg-image: url('{ads.cfitRec.fallbackImgUrl}')"
										on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
							</div>
						</div>
					{:else}
						<div use:scaleAdOnHover class="commercial" class:playing={ads.cfitRec.playing} on:click={() => startAd(ads.cfitRec, () => ads = ads)}>
							<!-- NOT PLAYING -->
							<img loading="eager" alt="Website-Screenshot"
								 src="./../img/01.Home/04.apps-und-ads/cfit-hintergrund.webp">
							<div class="container-overlay">
								<img loading="eager" alt={ads.cfitRec.imageAltText} src={ads.cfitRec.fallbackImgUrl}/>
								<button aria-label="play Ad - {ads.cfitRec.imageAltText}" class="playbutton small"></button>
							</div>
						</div>
					{/if}
				</div>
				<!-- End - Ad -->
			</div>
		</div>
		
		<div class="flex col structure-2">
			<div class="flex cfitPerformance">
				<!-- Beginning - Ad: cfitPerformance -->
				<div bind:this={ads.cfitPerformance.element} class="content"
					 style="
								 --scale: {ads.cfitPerformance.scale};
								 --origWidth: {ads.cfitPerformance.origWidth || 0}px;
								 --origHeight: {ads.cfitPerformance.origHeight || 0}px;
							">
					{#if ads.cfitPerformance.playing}
						<div class="commercial" class:playing={ads.cfitPerformance.playing}>
							<!-- PLAYING -->
							<iframe scrolling="no" src={ads.cfitPerformance.iframeIndexUrl}
									style="--bg-image: url('{ads.cfitPerformance.fallbackImgUrl}')"
									on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
						</div>
					{:else}
						<div use:scaleAdOnHover class="commercial" class:playing={ads.cfitPerformance.playing} on:click={() => startAd(ads.cfitPerformance, () => ads = ads)}>
							<!-- NOT PLAYING -->
							<img loading="lazy" alt={ads.cfitPerformance.imageAltText} src={ads.cfitPerformance.fallbackImgUrl}/>
							<button aria-label="play Ad - {ads.cfitPerformance.imageAltText}" class="playbutton small"></button>
						</div>
					{/if}
				</div>
				<!-- End - Ad -->
			</div>
			
			<div class="flex cfitWide">
				<!-- Beginning - Ad: cfitWide -->
				<div bind:this={ads.cfitWide.element} class="content"
					 style="
								 --scale: {ads.cfitWide.scale};
								 --origWidth: {ads.cfitWide.origWidth || 0}px;
								 --origHeight: {ads.cfitWide.origHeight || 0}px;
							">
					{#if ads.cfitWide.playing}
						<div class="commercial" class:playing={ads.cfitWide.playing}>
							<!-- PLAYING -->
							<iframe scrolling="no" src={ads.cfitWide.iframeIndexUrl}
									style="--bg-image: url('{ads.cfitWide.fallbackImgUrl}')"
									on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
						</div>
					{:else}
						<div use:scaleAdOnHover class="commercial" class:playing={ads.cfitWide.playing} on:click={() => startAd(ads.cfitWide, () => ads = ads)}>
							<!-- NOT PLAYING -->
							<img loading="lazy" alt={ads.cfitWide.imageAltText} src={ads.cfitWide.fallbackImgUrl}/>
							<button aria-label="play Ad - {ads.cfitWide.imageAltText}" class="playbutton small"></button>
						</div>
					{/if}
				</div>
				<!-- End - Ad -->
			</div>
		</div>
		
		<div class="flex row structure-3">
			<div class="flex element">
				<img loading="lazy" alt="clever Fit - mobile-Ad" src="./../img/17.Health_And_Care/02.cleverfit/MobileAd_640x832.webp">
			</div>
		</div>
		
		<div class="flex row structure-4">
			<div class="flex cfitBauchFrau">
				<!-- Beginning - Ad: cfitBauchFrau -->
				<div bind:this={ads.cfitBauchFrau.element} class="content"
					 style="
								 --scale: {ads.cfitBauchFrau.scale};
								 --origWidth: {ads.cfitBauchFrau.origWidth || 0}px;
								 --origHeight: {ads.cfitBauchFrau.origHeight || 0}px;
							">
					{#if ads.cfitBauchFrau.playing}
						<div class="commercial" class:playing={ads.cfitBauchFrau.playing}>
							<!-- PLAYING -->
							<iframe scrolling="no" src={ads.cfitBauchFrau.iframeIndexUrl}
									style="--bg-image: url('{ads.cfitBauchFrau.fallbackImgUrl}')"
									on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
						</div>
					{:else}
						<div use:scaleAdOnHover class="commercial" class:playing={ads.cfitBauchFrau.playing} on:click={() => startAd(ads.cfitBauchFrau, () => ads = ads)}>
							<!-- NOT PLAYING -->
							<img loading="lazy" alt={ads.cfitBauchFrau.imageAltText} src={ads.cfitBauchFrau.fallbackImgUrl}/>
							<button aria-label="play Ad - {ads.cfitBauchFrau.imageAltText}" class="playbutton small"></button>
						</div>
					{/if}
				</div>
				<!-- End - Ad -->
			</div>
			<div class="flex cfitBauchMann">
				<!-- Beginning - Ad: cfitBauchMann -->
				<div bind:this={ads.cfitBauchMann.element} class="content"
					 style="
								 --scale: {ads.cfitBauchMann.scale};
								 --origWidth: {ads.cfitBauchMann.origWidth || 0}px;
								 --origHeight: {ads.cfitBauchMann.origHeight || 0}px;
							">
					{#if ads.cfitBauchMann.playing}
						<div class="commercial" class:playing={ads.cfitBauchMann.playing}>
							<!-- PLAYING -->
							<iframe scrolling="no" src={ads.cfitBauchMann.iframeIndexUrl}
									style="--bg-image: url('{ads.cfitBauchMann.fallbackImgUrl}')"
									on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
						</div>
					{:else}
						<div use:scaleAdOnHover class="commercial" class:playing={ads.cfitBauchMann.playing} on:click={() => startAd(ads.cfitBauchMann, () => ads = ads)}>
							<!-- NOT PLAYING -->
							<img loading="lazy" alt={ads.cfitBauchMann.imageAltText} src={ads.cfitBauchMann.fallbackImgUrl}/>
							<button aria-label="play Ad - {ads.cfitBauchMann.imageAltText}" class="playbutton small"></button>
						</div>
					{/if}
				</div>
				<!-- End - Ad -->
			</div>
		</div>
		
		<div class="flex col structure-5">
			<div class="flex element">
				<div class="text">
					<h2 class="caption">{getText("17.02.01_h2")}</h2>
					<p class="caption">{getText("17.02.02_caption")}</p>
					<p class="caption blue">Project Lead: <a href="//www.zebra.de" target="_blank">Zebra</a></p>
				</div>
			</div>
				<div class="flex element">
					<img loading="lazy" alt="clever Fit - Banner-Ad" src="./../img/17.Health_And_Care/02.cleverfit/cfit-banner-3oo_x_25o_Online_anitest.webp">
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}

	.page-health-cleverfit {
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
		}
		
		.structure-1,
		.structure-2,
		.structure-3,
		.structure-4,
		.structure-5 {
			width: 100%;
			padding: 0;
			position: relative;
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.structure-1 {
			margin-top: $spacing-mobile;

			.commercial {
				width: 100%;
				height: fit-content;
				aspect-ratio: 1742 / 1450;
			}
			.rec {
				max-width: unset;
				max-height: unset;
			}

			iframe {
				scale: calc(var(--scale) * 0.8) !important;
				height: calc(var(--origHeight)) !important;
				width: calc(var(--origWidth)) !important;
			}
		}
		
		.structure-2 {
			display: block;
			gap: $media-gap;
			
			> .flex {
				margin-bottom: $media-gap;
			}
			
			@include for-tablet-portrait-up {
				display: flex;
				flex-flow: row nowrap;
				margin-bottom: 0;
			}
		}
		
		.structure-3 {
			@include for-tablet-portrait-up {
				width: 40%;
				padding-right: $media-gap;
			}

			@include for-desktop-up {
				width: 45%;
			}
		}
		
		.structure-4 {
			flex-flow: row nowrap;
			justify-content: center;
			max-width: calc(240px + $media-gap);
			
			.flex:first-of-type {
				margin-right: $media-gap;
			}
			
			.flex {
				flex: auto;
				margin-bottom: $media-gap;
				
				@include for-big-desktop-up {
					max-height: 600px;
				}
			}

			@include for-desktop-up {
				width: 30%;
				
				> .element {
					min-width: auto;
				}
			}
			
			@include for-desktop-up {
				width: 25%;
			}
		}
		
		.structure-5 {
			flex-wrap: nowrap;

			@include for-desktop-up {
				width: 30%;
				padding-left: $media-gap;
				justify-content: space-between;
				max-height: 600px;

				> .element:nth-of-type(2) {
					padding-right: 5vw;
					margin-bottom: 0;

					img {
						height: fit-content;
					}
				}
			}

			.text {
				margin: 0;
			}
		}
	}

	.rec {
		max-width: 720px;
		max-height: 480px;
		margin: 0 0 $media-gap 0;
		flex-grow: 1;

		@include for-tablet-portrait-up {
			margin: 0 0 $media-gap 0;
		}

		.commercial {
			overflow: hidden;
		}

		.container-overlay {
			position: absolute;
			width: 80%;
			height: fit-content;
			left: 10%;
			top: 18%;

			@include for-desktop-up {
				top: 11%;
			}
		}

		.scaled-iframe {
			width: 720px;
			height: 480px;
			border: 0;

			zoom: 1;
			transform: scale(1);
			transform-origin: 0 0;
		}
	}

	.playing .container-overlay > img {
		opacity: 0;
	}

	.rec iframe, .cfitPerformance iframe, .cfitWide iframe, .cfitBauchFrau iframe, .cfitBauchMann iframe {
		width: 100%;
		height: 100%;

		position: absolute;
		left: 0;
	}
	.rec iframe {
		top: 0;
	}

	iframe {
		border: none;
		background-image: var(--bg-image);
		background-size: cover;
	}

	:global(iframe[loaded]) {
		background-image: none !important;
	}

	.cfitPerformance .commercial, .cfitBauchFrau .commercial, .cfitBauchMann .commercial {
		transform-origin: center;
		scale: var(--scale);
	}

	.cfitWide .commercial img,
	.cfitWide .commercial iframe {
		scale: var(--scale);
	}
	.cfitWide .commercial img {
		@include for-phone-only {
			scale: unset;
		}
	}

	.cfitPerformance {
		flex: calc(941 / 784);
		max-width: 300px;

		.commercial {
			height: var(--origHeight);
			width: var(--origWidth);
		}
	}

	.cfitWide {
		flex: calc(975 / 250);

		.content {
			width: 0;

			@include for-tablet-portrait-up {
				height: 100%;
			}
		}

		.commercial {
			height: 100% !important;
			width: 100% !important;
			top: 0;
			display: flex;
			align-items: center;

			@include for-phone-only {
				height: calc(var(--origHeight) * var(--scale));
			}

			&.paused {
				max-height: 100%;
				max-width: 100%;

				@include for-phone-only {
					height: fit-content;
				}
			}

			> img, > iframe {

				@include for-phone-only {
					top: 0;
					position: relative;
				}
			}
			> img {
				position: relative;

				@include for-phone-only {
					top: 0;
					position: relative;
				}
			}

			:global(.greyOverlay) {
				top: 50%;
				transform: translateY(-50%);
			}

			> iframe {
				position: absolute;
				top: 0;
				left: 0;
				transform-origin: left;

				@include for-phone-only {
					transform-origin: top left;
					transform: none;
					left: 0;
					height: var(--origHeight);
				}

			}
		}
	}

	.cfitBauchFrau , .cfitBauchMann {
		align-self: start;
		width: 50%;

		@include for-tablet-portrait-up {
			margin-bottom: 0 !important;
		}

		.content {
			max-width: 100%;
			margin-bottom: $media-gap;
			@include for-tablet-portrait-up {
				margin-bottom: 0;
			}
		}
		.commercial {
			margin-top: $media-gap;
			position: relative;
			height: 600px;
			left: 50%;
			top: 100%;
			max-width: 100%;
			transform: translateX(-50%) translateY(-100%);
			transform-origin: top;

			@include for-tablet-portrait-up {
				margin-top: 0;
				scale: var(--scale);
			}

			> img, > iframe {
				max-width: 120px;
				max-height: 600px;
				position: relative;
				top: 0;
			}
		}
	}

	.structure-3 > .element {
		position: relative;
	}
</style>
